// extracted by mini-css-extract-plugin
export var legendIndicator = "_dj-1";
export var legendRight = "_dj-0";